export enum DeliveryType {
	MISSING_VALUE = "MISSING_VALUE",
	EMPLOYEE_RELOCATION = "EMPLOYEE_RELOCATION",
	CDP_DEVELOPMENT = "CDP_DEVELOPMENT",
	PRODUCT_DEVELOPMENT = "PRODUCT_DEVELOPMENT",
	MAINTENANCE = "MAINTENANCE",
	ADVISORY = "ADVISORY",
}
